import * as Sentry from '@sentry/react'

/**
 * Check if the current hostname is a local development environment.
 * This prevents sending errors to Sentry when developing locally.
 */
function isLocalhost(): boolean {
	const hostname = window.location.hostname
	return (
		hostname === 'localhost' ||
		hostname === '127.0.0.1' ||
		hostname === '0.0.0.0' ||
		hostname.startsWith('192.168.') ||
		hostname.startsWith('10.') ||
		hostname.endsWith('.local')
	)
}

export function initSentry(): void {
	const dsn = import.meta.env.VITE_SENTRY_DSN

	if (!dsn) {
		console.warn('Sentry DSN not configured, error tracking disabled')
		return
	}

	if (isLocalhost()) {
		console.info('Sentry disabled for localhost environment')
		return
	}

	Sentry.init({
		dsn,
		environment:
			import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
		release: import.meta.env.VITE_SENTRY_RELEASE,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],
		tracesSampleRate: 0.1,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		beforeSend(event) {
			// Double-check: filter out events from localhost in case init was called before DOM was ready
			if (isLocalhost()) {
				return null
			}
			return event
		},
	})
}

export { Sentry }
